<template>
  <div class="messages-container col-12">
    <tabs />
    <div class="messages-header col-12">
      <span class="title">A/B TESTS</span>
      <div class="create-button" @click="routeToABTest()">
        <i class="fas fa-plus" style="margin-right: 5px;" />
        <span>CREATE NEW A/B TEST</span>
      </div>
    </div>
    <div class="filters-section">
      <input 
        class="search-input" 
        type="text" 
        v-model="searchFilter" 
        placeholder="Search test name..."
      />
      <div class="btn-group" role="group">
        <button
          type="button"
          :class="`btn btn-sm ${statusFilters.draft ? 'btn-success' : 'btn-secondary'}`"
          @click="toggleStatusFilter('draft')"
        >
          Draft
        </button>
        <button
          type="button"
          :class="`btn btn-sm ${statusFilters.scheduled ? 'btn-success' : 'btn-secondary'}`"
          @click="toggleStatusFilter('scheduled')"
        >
          Scheduled
        </button>
        <button
          type="button"
          :class="`btn btn-sm ${statusFilters.delivered ? 'btn-success' : 'btn-secondary'}`"
          @click="toggleStatusFilter('delivered')"
        >
          Delivered
        </button>
      </div>
    </div>
    <div class="flex1">
      <div class="row titles">
        <div class="col-md-1 col-12 text-center">
          Status
        </div>
        <div class="col-md-2 col-12">
          Test Name
        </div>
        <div class="col-md-1 col-12 text-center">
          Id
        </div>
        <div class="col-md-1 col-12 text-center sortable" @click="changeSortParams('sendTime')">
          Send At {{ getSortIcon('sendTime') }}
        </div>
        <div class="col-md-1 col-12 text-center">
          Audience
        </div>
        <div class="col-md-1 col-12 text-center sortable" @click="changeSortParams('audienceCount')">
          Audience Count {{ getSortIcon('audienceCount') }}
        </div>
        <div class="col-md-1 col-12 text-center sortable" @click="changeSortParams('sent')">
          Sent {{ getSortIcon('sent') }}
        </div>
        <div class="col-md-1 col-12 text-center sortable" @click="changeSortParams('clicked')">
          Clicked {{ getSortIcon('clicked') }}
        </div>
        <div class="col-md-1 col-12 text-center sortable" @click="changeSortParams('ctr')">
          CTR {{ getSortIcon('ctr') }}
        </div>
        <div class="col-md-1 col-12 text-center">
          Actions
        </div>
      </div>
      <div class="row line-hover" v-for="message in filteredAndSortedABTests" :key="`message-${message.id}`"
        @click="$router.push({ name: 'MessagesABTest', params: { id: message.id } })">
        <div class="col-md-1 col-12 text-center center-para">
          <div class="badge"
            :class="message.status === 'delivered' ? 'badge-success' : (message.status === 'scheduled' ? 'badge-warning' : (message.status === 'draft' ? 'badge-secondary' : 'badge-info'))"
            style="text-transform: capitalize;">
            {{ message.status }}
          </div>
        </div>
        <div class="col-md-2 col-12 center-para">
          {{ message.name }}
        </div>
        <div class="col-md-1 col-12 text-center" @click.stop="copyToClipBoard(message.id)">
          {{ message.id.slice(0, 10) }}...
        </div>
        <div class="col-md-1 col-12 text-center center-para">
          {{ dateFormatter(message.schedule.sendTime) }}
        </div>
        <div class="col-md-1 col-12 text-center center-para">
          {{ message.audience.sendToAll ? 'All' : message.audience.includedAudience.map(audience =>
              audience.name).join(', ')
          }}
        </div>
        <div class="col-md-1 col-12 text-center">
          <span :class="getAudienceCountClass(message)">
            {{ getAudienceCountDisplay(message) }}
          </span>
        </div>
        <div class="col-md-1 col-12 text-center">
          {{ showStatistics(message, 'sent') }}
        </div>
        <div class="col-md-1 col-12 text-center">
          {{ showStatistics(message, 'clicked')
          }}
        </div>
        <div class="col-md-1 col-12 text-center">
          <div class="row justify-content-md-center">
            A: 
            {{ (message && message.statistics && message.statistics[message.messages[0].variantName]) ?
                ctr(message.statistics[message.messages[0].variantName] && message.statistics[message.messages[0].variantName].clicked ? message.statistics[message.messages[0].variantName].clicked : 0,
                  message.statistics[message.messages[0].variantName] && message.statistics[message.messages[0].variantName].sent ? message.statistics[message.messages[0].variantName].sent : 0) 
                : message && message.statistics && message.statistics.a ?  
                ctr(message.statistics.a && message.statistics.a.clicked ? message.statistics.a.clicked : 0,
                message.statistics.a && message.statistics.a.sent ? message.statistics.a.sent : 0) 
                : 'NaN'
            
            }}
          </div>
          <div class="row justify-content-md-center">

            B:
            {{ (message && message.statistics && message.statistics[message.messages[1].variantName]) ?
                ctr(message.statistics[message.messages[1].variantName] && message.statistics[message.messages[1].variantName].clicked ? message.statistics[message.messages[1].variantName].clicked : 0,
                  message.statistics[message.messages[1].variantName] && message.statistics[message.messages[1].variantName].sent ? message.statistics[message.messages[1].variantName].sent : 0) 
                : message && message.statistics && message.statistics.b ?  
                ctr(message.statistics.b && message.statistics.b.clicked ? message.statistics.b.clicked : 0,
                message.statistics.b && message.statistics.b.sent ? message.statistics.b.sent : 0) 
                : 'NaN'
            
            }}
          </div>

        </div>
        <div class="col-md-1 col-12 text-center center-para">
          <popup-menu>
            <template v-slot:trigger>
              <i class="fas fa-ellipsis-v" />
            </template>
            <template v-slot:content>
              <a style="cursor: pointer; color: white; margin: 5px 0;" @click.stop="$router.push({ name: 'MessagesABTest', params: { id: message.id } })">
                <i class="fas fa-pen-square" />
                {{ message.status === 'delivered' ? 'View' : 'Edit & View' }}
              </a>
              <a style="cursor: pointer; color: white; margin: 5px 0;" @click.stop="() => duplicateABTest(message)">
                <i class="fas fa-copy" />
                Duplicate
              </a>
              <a style="cursor: pointer; color: red; margin: 5px 0;" @click.stop="() => deleteABTest(message)">
                <i class="fas fa-ban" />
                {{ message.status === 'scheduled' ? 'Cancel' : 'Delete' }}
              </a>
            </template>
          </popup-menu>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PopupMenu from "@/views/PushNotification/UIComponents/PopupMenu";
import Tabs from "@/views/PushNotification/Tabs";
import formatters from "@/util/formatters";
import { ctr } from "@/util/ctr";
import notify from "@/util/notification";
const isLocal = window.location.href.indexOf("localhost") >= 0;
const cancelBigqueryJobUrl = isLocal ? "http://localhost:5002/audienceCount/cancel-bigquery-job" : "/audienceCount/cancel-bigquery-job";

export default {
  name: "ABTests",
  components: {
    PopupMenu,
    Tabs
  },
  computed: {
    abTests() {
      return this.$store.getters.abTests
    },
    appId() {
      return this.$store.getters.activeApp
    },
    filteredAndSortedABTests() {
      let filtered = this.abTests.filter(message => {
        const statusMatch = this.statusFilters[message.status];
        const searchMatch = message.name.toLowerCase().includes(this.searchFilter.toLowerCase());
        return statusMatch && searchMatch;
      });
      return filtered.sort(this.sorter);
    }
  },
  methods: {
    toggleStatusFilter(status) {
      this.statusFilters[status] = !this.statusFilters[status];
    },
    changeSortParams(field) {
      if (this.sortParams.field === field) {
        this.sortParams.direction = this.sortParams.direction === 'ASC' ? 'DESC' : 'ASC';
      } else {
        this.sortParams = { field, direction: 'DESC' };
      }
    },
    getSortIcon(field) {
      if (this.sortParams.field !== field) return '';
      return this.sortParams.direction === 'ASC' ? '↑' : '↓';
    },
    sorter(a, b) {
      const { field, direction } = this.sortParams;
      let aValue, bValue;

      switch(field) {
        case 'sendTime':
          aValue = a.schedule.sendTime || 0;
          bValue = b.schedule.sendTime || 0;
          break;
        case 'audienceCount':
          aValue = a.audience_count?.status === 'DONE' ? a.audience_count.value : 0;
          bValue = b.audience_count?.status === 'DONE' ? b.audience_count.value : 0;
          break;
        case 'sent':
          const aSentA = a.statistics?.[a.messages[0].variantName]?.sent || a.statistics?.a?.sent || 0;
          const aSentB = a.statistics?.[a.messages[1].variantName]?.sent || a.statistics?.b?.sent || 0;
          aValue = aSentA + aSentB;
          const bSentA = b.statistics?.[b.messages[0].variantName]?.sent || b.statistics?.a?.sent || 0;
          const bSentB = b.statistics?.[b.messages[1].variantName]?.sent || b.statistics?.b?.sent || 0;
          bValue = bSentA + bSentB;
          break;
        case 'clicked':
          const aClickedA = a.statistics?.[a.messages[0].variantName]?.clicked || a.statistics?.a?.clicked || 0;
          const aClickedB = a.statistics?.[a.messages[1].variantName]?.clicked || a.statistics?.b?.clicked || 0;
          aValue = aClickedA + aClickedB;
          const bClickedA = b.statistics?.[b.messages[0].variantName]?.clicked || b.statistics?.a?.clicked || 0;
          const bClickedB = b.statistics?.[b.messages[1].variantName]?.clicked || b.statistics?.b?.clicked || 0;
          bValue = bClickedA + bClickedB;
          break;
        case 'ctr':
          const aTotalSent = (a.statistics?.[a.messages[0].variantName]?.sent || a.statistics?.a?.sent || 0) + 
                             (a.statistics?.[a.messages[1].variantName]?.sent || a.statistics?.b?.sent || 0);
          const aTotalClicked = (a.statistics?.[a.messages[0].variantName]?.clicked || a.statistics?.a?.clicked || 0) + 
                                (a.statistics?.[a.messages[1].variantName]?.clicked || a.statistics?.b?.clicked || 0);
          aValue = aTotalSent > 0 ? (aTotalClicked / aTotalSent) : 0;
          
          const bTotalSent = (b.statistics?.[b.messages[0].variantName]?.sent || b.statistics?.a?.sent || 0) + 
                             (b.statistics?.[b.messages[1].variantName]?.sent || b.statistics?.b?.sent || 0);
          const bTotalClicked = (b.statistics?.[b.messages[0].variantName]?.clicked || b.statistics?.a?.clicked || 0) + 
                                (b.statistics?.[b.messages[1].variantName]?.clicked || b.statistics?.b?.clicked || 0);
          bValue = bTotalSent > 0 ? (bTotalClicked / bTotalSent) : 0;
          break;
        default:
          return 0;
      }

      if (aValue < bValue) return direction === 'ASC' ? -1 : 1;
      if (aValue > bValue) return direction === 'ASC' ? 1 : -1;
      return 0;
    },
    showStatistics(message, statisticType) {
      const aVariantName = message.messages[0].variantName
      const bVariantName = message.messages[1].variantName
      if (aVariantName) {
        return `A: ${message.statistics[aVariantName] ? message.statistics[aVariantName][statisticType] : 'NaN'}  
      B: ${message.statistics[bVariantName] ? message.statistics[bVariantName][statisticType] : 'NaN'}  `
      }
      else {
        return 'A:' + (message.statistics.a ? message.statistics.a[statisticType] : 'NaN') + ', B:' + (message.statistics.b ?
          message.statistics.b[statisticType] : 'NaN')

      }
    },
    getAudienceCountDisplay(message) {
      if (!message.audience_count) return 'N/A';
      
      switch(message.audience_count.status) {
        case 'PENDING': return 'Pending...';
        case 'DONE': return message.audience_count.value;
        case 'ERROR': return 'Error';
        case 'TIMEOUT': return 'Timeout';
        default: return 'N/A';
      }
    },
    getAudienceCountClass(message) {
      if (!message.audience_count) return '';
      
      switch(message.audience_count.status) {
        case 'ERROR': return 'text-danger';
        case 'TIMEOUT': return 'text-warning';
        case 'PENDING': return 'text-info';
        default: return '';
      }
    },
    copyToClipBoard(messageId) {
      const tempInput = document.createElement("input");
      tempInput.value = messageId;
      document.body.appendChild(tempInput);
      tempInput.select();
      document.execCommand("copy");
      document.body.removeChild(tempInput);
    },
    async routeToABTest() {
      if (!this.canSendPushNotifications && !this.canCreateDraftMessages) {
        return notify('You are not authorized to send push notifications or create draft messages', "error")
      }
      this.$router.push({ name: 'MessagesABTest' })
    },
    duplicateABTest(message) {
      const payload = { ...message }

      payload.name += '_copy'
      payload.status = 'draft'
      if (message.audience_count) {
        delete payload.audience_count;
      }
      payload.cloudTaskName = undefined
      payload.schedule.sendTime = Date.now()
      delete payload.id
      // TODO: fix statistics
      payload.statistics = {}
      payload.statistics[payload.messages[0].variantName] = { sent: 0, clicked: 0 }
      payload.statistics[payload.messages[1].variantName] = { sent: 0, clicked: 0 }
      this.$store.dispatch('configAdd', { type: 'message', payload });
    },
    deleteABTest(message) {
      if (
        confirm(
          `You are trying to delete "${message.name
          }" test. Are you sure?`
        )
      ) {
        if (message.status === 'scheduled') {
          const newMessage = { ...message }
          newMessage.status = 'draft'
          const payload = { id: message.id, data: newMessage }
          this.$store.dispatch('configEdit', { type: 'message', payload });
        } else {
          this.$store.dispatch('configDelete', { type: 'message', payload: message.id });
          // if the message have active audience count job, cancel it
          if (message.audience_count && message.audience_count.status === 'PENDING') {
            fetch(cancelBigqueryJobUrl, { method: 'POST', body: JSON.stringify({ jobId: message.audience_count.jobId, appId: this.appId }), headers: { authorization: this.$store.getters.pushNotifApiKey, "Content-Type": "application/json" } });
          }
        }
      }
    }
  },
  data() {
    return {
      dateFormatter: formatters.dateFormatter,
      ctr,
      searchFilter: '',
      statusFilters: {
        draft: true,
        scheduled: true,
        delivered: true
      },
      sortParams: {
        field: 'sendTime',
        direction: 'DESC'
      }
    }
  }

}
</script>

<style scoped>
.messages-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 25px 0;
}

.title {
  font-size: 24px;
}

.create-button {
  cursor: pointer;
  border-radius: 28px;
  background: #03B3DA;
  color: white;
  padding: 10px 15px;
  font-size: 14px;
}

.titles > div {
  padding-left: 5px;
  padding-right: 5px;
  font-size: 24px;
}

.filters-section {
  display: flex;
  align-items: center;
  gap: 15px;
  margin-bottom: 20px;
}

.search-input {
  padding: 5px 10px;
  border-radius: 6px;
  border: 1px solid rgba(255, 255, 255, 0.3);
  background-color: rgba(255, 255, 255, 0.1);
  color: white;
  min-width: 200px;
}

.search-input::placeholder {
  color: rgba(255, 255, 255, 0.5);
}

.sortable {
  cursor: pointer;
  user-select: none;
}

.sortable:hover {
  opacity: 0.8;
}
</style>